<div>
    <table  class="table table-striped table-sm m-0 p-0">
        <tbody>
            <tr>
                <th role="button" (click)="bExpanded=!bExpanded">                                
                    <div class="d-flex flex-wrap">
                        <div *ngIf="_mapPoint?.name" style="color: black; background-color: white; border-radius: 8px;" 
                        class="px-sm-1 text-center font-weight-bold"
                        [ngStyle]="{border: 'solid 2px ' + _mapPoint.color}">
                            {{_mapPoint.name}}
                        </div>
                        <div class="px-1">
                            {{_mapPoint?.pointId}} 
                        </div>
                        <div *ngIf="_mapPoint && _mapPoint.pointId && (_mapPoint.latitude != null || _mapPoint.longitude != null) ; else missingPtData">
                            (lat: {{_mapPoint.latitude|number:'1.0-6'}}, 
                            lng: {{_mapPoint.longitude|number:'1.0-6'}})
                            <i class="pl-2 fa small" [ngClass]="'fa-chevron-'+(bExpanded?'down':'right')"></i>
                        </div>
                        <ng-template #missingPtData>                         
                            <div *ngIf="_mapPoint" class="font-italic small">
                                <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
                                Missing data (Point ID: {{_mapPoint.pointId}} 
                                lat: {{_mapPoint.latitude|number:'1.0-6'}}, 
                                lng: {{_mapPoint.longitude|number:'1.0-6'}})
                            </div>                            
                        </ng-template>
                    </div>
                </th>
            </tr>
            <ng-container *ngIf="bExpanded && _mapPoint">
                <tr *ngIf="_mapPoint.parentId">
                    <td>
                        {{_mapPoint.parentHorizontalDistance|number:'1.0-2'}}m @ {{_mapPoint.parentBearing|number:'1.0-2'}}&deg;
                        from
                        <span [ngStyle]="{color: _mapPoint.parentColor}" class="font-weight-bold">
                            {{_mapPoint.parentName}}
                        </span>
                    </td>
                </tr>
                <ng-container *ngIf="_mapPoint.pointId && pointQuery$ | async as pt">
                    <ng-container *ngIf="pt">
                    <tr>
                        <td>
                            <b>Ref 1:</b> {{pt.wRef1}},
                            <b>Ref 2:</b> {{pt.wRef1}},
                            <b>Quadrant</b> {{pt.quadrant}}
                        </td>
                    </tr>
                    <tr>
                    <td *ngIf="_mapPoint?.pointId && pointQuery$ | async as pt" style="width: 400px;">
                        {{pt?.locationDescription}}
                    </td>
                    </tr>
                    </ng-container>
                </ng-container>
            </ng-container>
        </tbody>
    </table>
    </div>
